import { Button, Icons } from '@cast/design-system';

import { ScalingPolicyVpaFormFields } from '../../_constants/_constants';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { useVpaSelectedSettingName } from '../../vpaSelectedSettingNameContexts';

export const NextVpaSettingsButton = () => {
  const { settingName, setSettingName, settingsList } =
    useVpaSelectedSettingName<ScalingPolicyVpaFormFields>();

  const nextSettingName =
    settingsList[settingsList.indexOf(settingName) + 1] || settingsList[0];

  const { title } = vpaSettingsConstants[nextSettingName];

  return (
    <Button
      variant="text"
      endIcon={<Icons.ArrowDown />}
      onClick={() => setSettingName(nextSettingName)}
      data-testid="next-setting-button"
    >
      {title}
    </Button>
  );
};
